import useEnvironment from '~/composable/various/useEnvironment';
export default ($axios) => ({


  login(userName, password) {
    const { isDevEnv } = useEnvironment();
    let baseUrl = window.location.protocol + '//' + window.location.hostname + '/gw';

    if (isDevEnv()) {
      baseUrl = 'http://localhost:7001';
    }
    const url = `${baseUrl}/api/self-service/authenticate`;
    return $axios.post(url,
      { username: userName, password })
  }
})
